/**
 * NST ADVISORY - Motion Design Orchestrator
 * Corporate/Premium Archetype (cubic-bezier(0.2, 0, 0, 1), 200-400ms duration)
 * Implements 3 Motion Layers: Primary (entrance), Secondary (elevation/border), Ambient (pulse/drift)
 */

document.addEventListener('DOMContentLoaded', () => {
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReducedMotion) return;

  // 1. Scroll-Triggered Staggered Reveals
  const revealElements = document.querySelectorAll('.reveal-on-scroll');
  if (revealElements.length > 0) {
    const revealObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        }
      });
    }, {
      root: null,
      threshold: 0.12,
      rootMargin: '0px 0px -40px 0px'
    });

    revealElements.forEach((el, index) => {
      revealObserver.observe(el);
    });
  }

  // 2. Button Micro-Feedback (Tactile Anticipation & Settle)
  const buttons = document.querySelectorAll('.btn-primary, .btn-secondary, button[type="submit"]');
  buttons.forEach(btn => {
    btn.addEventListener('mousedown', () => {
      btn.style.transform = 'translateY(1px) scale(0.985)';
    });
    btn.addEventListener('mouseup', () => {
      btn.style.transform = '';
    });
    btn.addEventListener('mouseleave', () => {
      btn.style.transform = '';
    });
  });

});

